import {Fragment} from 'react';

import type {AfriexGroupedProcessorMetrics} from '@afriex/core/domain/types';

import {Accordion} from '@/components';

import SubProcessorTable from './SubProcessorTable';

const ProcessorAccordion = ({
  data: groupedByProcessor,
}: {
  data: AfriexGroupedProcessorMetrics;
}) => {
  return (
    <Fragment>
      {Object.keys(groupedByProcessor).map((processor) => (
        <Accordion
          key={processor}
          title={`Processor: ${processor}`}
          headerStyle="bg-gray-200 dark:bg-gray-800 shadow-sm py-1.5"
        >
          <SubProcessorTable
            groupedByProcessor={groupedByProcessor}
            processor={processor}
          />
        </Accordion>
      ))}
    </Fragment>
  );
};

export default ProcessorAccordion;
